import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { getFunctions, httpsCallable } from "firebase/functions";
import "./index.css";
import App from "./App.jsx";
import { AuthProvider } from "./app/AuthProvider.jsx";
import { ThemeProvider } from "./app/ThemeProvider.jsx";
import { AuthScopedEnrichmentCacheProvider } from "./features/calendar-enrichment/AuthScopedEnrichmentCacheProvider.jsx";
import { defaultGoogleCalendarTokenProvider } from "./features/calendar-enrichment/google-token-provider";
import { createProviderRegistry } from "./features/calendar-enrichment/providers";

const tokenProviders = {
  google: defaultGoogleCalendarTokenProvider({
    httpsCallable: (name) => httpsCallable(getFunctions(), name),
  }),
};

// VITE_GOOGLE_CALENDAR_API_BASE redirects browser-side enrichment fetches
// to a hermetic mock server during e2e (see
// functions/src/__tests__/mock-google-calendar-server.js). Production builds
// leave it unset so the provider falls back to https://www.googleapis.com.
const enrichmentRegistry = createProviderRegistry({
  googleBaseUrl: import.meta.env.VITE_GOOGLE_CALENDAR_API_BASE || undefined,
});

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <ThemeProvider>
      <AuthProvider>
        <AuthScopedEnrichmentCacheProvider
          registry={enrichmentRegistry}
          tokenProviders={tokenProviders}
        >
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthScopedEnrichmentCacheProvider>
      </AuthProvider>
    </ThemeProvider>
  </StrictMode>
);
